import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL?.trim();
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY?.trim();

/** False when URL/key missing — avoids crashing the whole app at import time */
export const supabaseConfigured = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);

export const supabase = supabaseConfigured
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: { persistSession: false },
    })
  : null;
